module.exports = __webpack_public_path__ + "assets/16c4de2d2dffdd00adb7bdd9d5597a7f.png";